export default __webpack_public_path__ + "static/media/success_tick.87aafcbd.svg";